import { LOCAL_STORAGE_PREFIX, StorageKey } from 'constant';

class Storage {
  constructor() {
    this.store = {};
  }

  getItem = (key, updateCache = false) => {
    if (!updateCache && key in this.store) return this.store[key];
    const value = localStorage.getItem(`${LOCAL_STORAGE_PREFIX}.${key}`);
    this.store[key] = value;
    return value;
  };

  setItem = (key, value) => {
    this.store[key] = value;
    localStorage.setItem(`${LOCAL_STORAGE_PREFIX}.${key}`, value);
  }

  removeItem = (key) => {
    this.store[key] = undefined;
    delete this.store[key];
    localStorage.removeItem(`${LOCAL_STORAGE_PREFIX}.${key}`);
  }

  getJson = (key, updateCache = false) => {
    const value = this.getItem(key, updateCache);
    try {
      return JSON.parse(value);
    } catch (error) {
      return value;
    }
  };

  setJson = (key, value) => this.setItem(key, JSON.stringify(value));

  log = () => {
    console.log('Storage', this.store);
  }

  getAccountingPeriod = () => {
    let period = this.getItem(StorageKey.PERIOD);
    if (!period) {
      const today = new Date();
      if (today > new Date(today.getFullYear(), 3, 1)) {
        period = today.getFullYear();
      } else {
        period = today.getFullYear() - 1;
      }
      this.setItem(StorageKey.PERIOD, period);
    } else {
      period = parseInt(period);
    }
    return period;
  }

  getSpaceToken = () => this.getItem('spaceToken')

  isInBeginPeriod = () => this.getAccountingPeriod() === parseInt(this.getItem('beginPeriod'));
}

export default new Storage();



// WEBPACK FOOTER //
// ./src/utils/storage.js